// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".report-footer{display:none;white-space:pre-wrap;z-index:1000}@media print{.report-footer{bottom:0;display:inline-block!important;position:fixed}}", ""]);
// Exports
module.exports = exports;
